import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import FooterSection from "@/components/FooterSection";
import EstimateCalculator from "@/components/EstimateCalculator";

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Home", item: "https://zenithsolutionsnm.com/" },
    { "@type": "ListItem", position: 2, name: "Tools", item: "https://zenithsolutionsnm.com/tools" },
    { "@type": "ListItem", position: 3, name: "Estimate Calculator", item: "https://zenithsolutionsnm.com/tools/estimate-calculator" },
  ],
};

const EstimateCalculatorPage = () => (
  <>
    <Helmet>
      <title>Free Online Estimate Calculator | Roofing, Solar, Construction | Zenith Solutions NM</title>
      <meta name="description" content="Get an instant estimate for roofing, solar, construction, or mold remediation in New Mexico. Uses 2026 market pricing with built-in variance for accuracy." />
      <link rel="canonical" href="https://zenithsolutionsnm.com/tools/estimate-calculator" />
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
    </Helmet>
    <Navbar />
    <div className="pt-24 pb-20 min-h-screen bg-section-light">
      <div className="container mx-auto max-w-2xl px-4">
        <nav aria-label="Breadcrumb" className="mb-6">
          <Link to="/tools" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors">
            <ArrowLeft className="h-4 w-4" /> Back to Tools
          </Link>
        </nav>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-10"
        >
          <p className="text-sm font-bold uppercase tracking-widest text-primary mb-3">Free Tool</p>
          <h1 className="text-3xl md:text-4xl font-black text-foreground mb-3">
            Instant Estimate Calculator
          </h1>
          <p className="text-muted-foreground max-w-lg mx-auto leading-relaxed">
            Answer a few questions about your project and get an estimated price range based on current 2026 New Mexico market rates.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <EstimateCalculator />
        </motion.div>
      </div>
    </div>
    <FooterSection />
  </>
);

export default EstimateCalculatorPage;
